import { tierThemes } from 'features/premium/benefits';
import { Tier } from 'features/premium/entities';
export const getEmmaIconColorProps = (userTier) => {
    if (userTier === Tier.free) {
        return { colorKey: 'secondary' };
    }
    const shortName = tierThemes[userTier].shortName.toLowerCase();
    const gradientKey = ['ultimate', 'pro', 'plus'].includes(shortName)
        ? shortName
        : 'ultimate';
    return { gradientKey };
};
